const moment = require("moment");

const store = require("../store.js");
const UploadHistoryActions = require("../actions/UploadHistoryActions.js");

const dispatch = store.dispatch;

const config = require("../Config.js");
const Server = require("../Server.js");

const recentHistoryDays = config.RecentHistoryDays || 5;

const UploadHistoryActionCreators = {
    GetRecent() {
        const days = -1 * recentHistoryDays;
        const start = moment().add(days, "day").format();
        
        UploadHistoryActionCreators.Get(start);
    },
    Get(startDate, endDate) {
        dispatch((thunkDispatch) => {
            thunkDispatch({
                type: UploadHistoryActions.Get
            });

            const url = `uploads/current-user?DateStart=${startDate}&DateEnd=${endDate}`

            Server.Get(url)
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    dispatch({
                        type: UploadHistoryActions.Got,
                        Data: json
                    });
                })
                .catch((ex) => {
                    dispatch({
                        type: UploadHistoryActions.GetErrored,
                        Error: ex
                    });
                });
        });
    },
    GetAll() {
        dispatch((thunkDispatch) => {
            thunkDispatch({
                type: UploadHistoryActions.GetAll
            });

            Server.Get("uploads/current-user")
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    dispatch({
                        type: UploadHistoryActions.GotAll,
                        Data: json
                    });
                })
                .catch((ex) => {
                    dispatch({
                        type: UploadHistoryActions.GotAllErrored,
                        Error: ex
                    });
                });
        });
    }
};

module.exports = UploadHistoryActionCreators;


// WEBPACK FOOTER //
// ./src/actionCreators/UploadHistoryActionCreators.js